import { Paper, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import LightTooltip from 'views/Components/Shared/Components/LightTooltip';

function DetailCard({ seller }) {
	return (
		<Paper
			sx={{
				width: '350px',
				borderLeft: '5px solid red',
				borderRadius: '0px',
				pl: '5px',
			}}
		>
			<Stack>
				<Typography
					sx={{
						color: 'red',
						fontSize: '14px',
						fontWeight: 600,
						lineHeight: '20px',
						letterSpacing: '0.17px',
						fontFamily: 'Roboto',
					}}
				>
					Otro seller esta ganando en el catalogo
				</Typography>

				<Typography
					sx={{
						color: 'rgba(0, 0, 0, 0.87)',
						fontSize: '14px',
						fontWeight: 400,
						lineHeight: '20px',
						letterSpacing: '0.17px',
						fontFamily: 'Roboto',
					}}
				>
					Otro seller esta ganando en el catalogo: SellerID {seller}
				</Typography>
			</Stack>
		</Paper>
	);
}

export default function HijackedFlagCard({ children, seller }) {
	return (
		<LightTooltip
			placement="top-start"
			customStyles={{
				maxWidth: '350px',
				padding: '0',
			}}
			title={<DetailCard seller={seller} />}
		>
			{children}
		</LightTooltip>
	);
}
